import { render, staticRenderFns } from "./ProgressNotification.vue?vue&type=template&id=4d28ee9b&"
import script from "./ProgressNotification.vue?vue&type=script&lang=js&"
export * from "./ProgressNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/Notifications.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fyurinascimento%2FDocuments%2FWork%2Ftristar%2Ftristar-courier-frontend%2Fsrc%2Fcomponents%2FNotifications%2FProgressNotification.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/i18n/notifications/index.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2FUsers%2Fyurinascimento%2FDocuments%2FWork%2Ftristar%2Ftristar-courier-frontend%2Fsrc%2Fcomponents%2FNotifications%2FProgressNotification.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports